import React, { useContext, useEffect, useMemo } from 'react';
import { useServerSidePaging } from '../hooks/useServerSidePaging';

export const ServerSidePagingContext = React.createContext()

export const ServerSidePagingProvider = ({ children }) => {
    const transactionServerSideState = useServerSidePaging();
    const value = useMemo(() => transactionServerSideState, [transactionServerSideState])

    //useEffect(() => { console.log("ServerSidePagingProvider => ", value) }, [value])

    return (
        <ServerSidePagingContext.Provider value={value}>
            {children}
        </ServerSidePagingContext.Provider>
    );
}

export function useServerSidePagingContext() {
    return useContext(ServerSidePagingContext)
}

